import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import { api } from "../lib/api";

export default function Blog() {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        api.get("/blog/posts").then(({ data }) => setPosts(data)).finally(() => setLoading(false));
    }, []);
    return (
        <div className="max-w-[1600px] mx-auto px-6 lg:px-10" data-testid="blog-page">
            <Seo title="Field Notes" description="Field notes from The Puro Pack — sustainability, manufacturing, and the business of foodservice packaging." path="/blog" />
            <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Blog", to: "/blog" }]} />

            <section className="pt-14 pb-16 grid lg:grid-cols-12 gap-10 items-end">
                <div className="lg:col-span-8">
                    <div className="font-mono text-xs uppercase tracking-widest text-clay mb-6">[ Field Notes · The Journal ]</div>
                    <h1 className="font-serif text-6xl lg:text-8xl leading-[0.95] tracking-tight text-forest">Notes from the <em className="italic">factory floor.</em></h1>
                </div>
                <p className="lg:col-span-4 text-inkgreen/80 leading-relaxed">Manufacturing, sustainability, and the strange business of running paper lines for a plastic-obsessed industry.</p>
            </section>

            <section className="pb-24 border-t border-forest/30">
                {loading && <div className="py-20 font-mono text-xs uppercase text-stone">Loading…</div>}
                {!loading && posts.length === 0 && <div className="py-20 font-mono text-xs uppercase text-stone">No posts yet.</div>}
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-0 border-l border-forest/30">
                    {posts.map((p) => (
                        <Link key={p.slug} to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="block group border-r border-b border-forest/30 p-8 hover:bg-sand transition-colors">
                            {p.cover_image && (
                                <div className="image-frame aspect-[16/10] mb-6">
                                    <img src={p.cover_image} alt={p.title} loading="lazy" />
                                </div>
                            )}
                            <div className="font-mono text-xs uppercase tracking-widest text-clay mb-3">{(p.tags || []).join(" · ")}</div>
                            <h3 className="font-serif text-3xl leading-tight text-forest tracking-tight mb-3">{p.title}</h3>
                            <p className="text-inkgreen/75 leading-relaxed text-sm">{p.excerpt}</p>
                            <div className="mt-6 text-xs font-mono uppercase tracking-widest text-forest group-hover:text-clay">Read →</div>
                        </Link>
                    ))}
                </div>
            </section>
        </div>
    );
}
